var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('website-header'),_c('top-nav'),_c('toast-messages'),_c('indeed-tracker'),(_vm.isSignedIn || _vm.isPublicRoute)?_c('div',[(_vm.canSeeRoute)?_c('router-view'):_c('no-access')],1):_c('div',[(_vm.isLoginPinRoute)?_c('router-view'):_c('login-signup')],1),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }